<template>
  <b-modal
    id="complete-assignment"
    hide-footer
    hide-header
    centered
    body-class="!p-[20px] md:!p-[32px]"
    dialog-class="!max-w-[1120px] !px-[calc(1rem+2vw)] md:!px-[calc(1rem+3vw)] 2xl:!px-0"
    @shown="handleModalShown"
  >
    <span class="text-[#222] font-semibold text-[20px]">Lengkapi Informasi Assignment</span>
    <b-overlay
      variant="light"
      :show="loading"
      spinner-variant="primary"
      blur="0"
      opacity=".5"
      rounded="sm"
    >
      <validation-observer
        ref="formRules"
        v-slot="{ invalid }"
      >
        <div class="flex gap-[24px] flex-wrap mt-[24px] md:mt-[32px] max-h-[603px] overflow-y-auto pb-[32px] [&_legend]:text-[#0A0A0A] [&_legend]:font-medium [&_legend]:text-[14px]">
          <div class="border-[1px] border-black/10 rounded-[14px] px-[20px] py-[24px] basis-[280px] grow min-h-fit">
            <span class="text-[24px] font-medium text-[#0A0A0A]">Form Data Talent</span>
            <hr class="mt-[28px] mb-[16px]">
            <div>
              <b-form-group v-if="mode === 'add'">
                <template #label>
                  Layanan
                </template>
                <validation-provider
                  #default="{ errors }"
                  name="Nama Skill"
                  rules="required"
                >
                  <v-select
                    v-model="role"
                    :reduce="option => option.name"
                    :options="listSkills"
                    label="name"
                    :clearable="false"
                    placeholder="Ketik untuk mencari..."
                  />
                  <small class="text-danger d-block mt-[2px]">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-form-group>
                <template #label>
                  Nama Talent
                </template>
                <validation-provider
                  #default="{ errors }"
                  name="Nama Talent"
                  rules="required"
                >
                  <v-select
                    v-model="talent"
                    :reduce="option => option"
                    :options="listTalent"
                    placeholder="Ketik untuk mencari..."
                    :disabled="!role || mode === 'edit'"
                    @search="(search) => search.length > 0 ? onSearchTalent(search) : ''"
                  />
                  <small class="text-danger d-block mt-[2px]">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-form-group>
                <template #label>
                  Nama Partner
                </template>
                <validation-provider
                  #default="{ errors }"
                  name="Nama Partner"
                  rules="required"
                >
                  <v-select
                    v-model="partner"
                    :reduce="option => option"
                    :options="listPartner"
                    placeholder="Ketik untuk mencari..."
                    :disabled="mode === 'edit'"
                    @search="(search) => search.length > 0 ? onSearchPartner(search) : ''"
                    @input="handleInput"
                  />
                  <small class="text-danger d-block mt-[2px]">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-form-group>
                <template #label>
                  Leader
                </template>
                <validation-provider
                  #default="{ errors }"
                  name="Leader"
                  rules="required"
                >
                  <v-select
                    v-model="leader"
                    label="name"
                    :reduce="option => option"
                    :options="listLeader"
                    placeholder="Ketik untuk mencari..."
                    @search="(search) => search.length > 0 ? onSearchLeader(search) : ''"
                  />
                  <small class="text-danger d-block mt-[2px]">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-form-group>
                <template #label>
                  Device
                </template>
                <validation-provider
                  #default="{ errors }"
                  name="Device"
                  rules="required"
                >
                  <v-select
                    v-model="device"
                    label="device_name"
                    :reduce="option => option"
                    :options="listDevice"
                    placeholder="Ketik untuk mencari..."
                    :disabled="!partner && mode === 'add'"
                  />
                  <small class="text-danger d-block mt-[2px]">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-form-group>
                <template #label>
                  Kantor
                </template>
                <validation-provider
                  #default="{ errors }"
                  name="Kantor"
                  rules="required"
                >
                  <v-select
                    v-model="office"
                    label="working_space_name"
                    :reduce="option => option"
                    :options="listOffice"
                    placeholder="Ketik untuk mencari..."
                  />
                  <small class="text-danger d-block mt-[2px]">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-form-checkbox
                v-model="isNewPartner"
                :value="true"
                :unchecked-value="false"
                :disabled="mode === 'edit'"
              >
                Talent di rekrut dari partner baru
              </b-form-checkbox>
            </div>
          </div>
          <div
            v-if="role === 'Admin Marketplace'"
            class="border-[1px] border-black/10 rounded-[14px] px-[20px] py-[24px] basis-[374px] grow min-h-fit"
          >
            <span class="text-[24px] font-medium text-[#0A0A0A]">Form Insentif Talent</span>
            <hr class="mt-[28px] mb-[16px]">
            <div>
              <b-form-group>
                <template #label>
                  Gaji Pokok
                </template>
                <validation-provider
                  #default="{ errors }"
                  name="Gaji Pokok"
                  rules="required|integer|min_value:0"
                >
                  <b-form-input
                    v-model.number="incentive.base_salary"
                    number
                    placeholder="Masukkan nominal"
                  />
                  <small class="text-danger d-block mt-[2px]">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <div class="[&_legend]:text-[#4A5565] [&_legend]:ml-[16px] [&_legend]:truncate [&_legend]:!max-w-[120px]">
                <div class="text-[#0A0A0A] font-medium text-[14px] mb-[12px]">
                  Performa Chat
                </div>
                <b-form-group
                  label-cols="4"
                  class="!mb-[12px]"
                >
                  <template #label>
                    Rate >95%
                  </template>
                  <validation-provider
                    #default="{ errors }"
                    name="Rate >95%"
                    rules="required|integer|min_value:0"
                  >
                    <b-form-input
                      v-model.number="incentive.chat_rate_high"
                      number
                      placeholder="Masukkan nominal"
                    />
                    <small class="text-danger d-block mt-[2px]">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
                <b-form-group
                  label-cols="4"
                  class="!mb-[12px]"
                >
                  <template #label>
                    Rate 85%-95%
                  </template>
                  <validation-provider
                    #default="{ errors }"
                    name="Rate 85%-95%"
                    rules="required|integer|min_value:0"
                  >
                    <b-form-input
                      v-model.number="incentive.chat_rate_mid"
                      number
                      placeholder="Masukkan nominal"
                    />
                    <small class="text-danger d-block mt-[2px]">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
                <b-form-group label-cols="4">
                  <template #label>
                    Rate &lt;85%
                  </template>
                  <validation-provider
                    #default="{ errors }"
                    name="Rate <85%"
                    rules="required|integer|min_value:0"
                  >
                    <b-form-input
                      v-model.number="incentive.chat_rate_low"
                      number
                      placeholder="Masukkan nominal"
                    />
                    <small class="text-danger d-block mt-[2px]">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </div>
              <div class="mb-[16px]">
                <div class="text-[#0A0A0A] font-medium text-[14px] mb-[12px]">
                  Update postingan (Feeds)
                </div>
                <div class="flex items-start gap-x-[20px] gap-y-[12px] flex-wrap w-fit max-w-[460px] md:max-w-none">
                  <div class="flex items-start gap-[12px] basis-[240px] grow">
                    <validation-provider
                      #default="{ errors }"
                      name="per post"
                      rules="required|integer|min_value:0"
                    >
                      <b-form-input
                        v-model.number="incentive.update_posting_rate"
                        number
                        placeholder="Masukkan nominal"
                      />
                      <small class="text-danger d-block mt-[2px]">{{ errors[0] }}</small>
                    </validation-provider>
                    <span class="text-[#6A7282] whitespace-nowrap h-[34.55px] flex items-center">per post</span>
                  </div>
                  <div class="flex items-start gap-[12px] basis-[200px] grow">
                    <validation-provider
                      #default="{ errors }"
                      name="post/bulan (max)"
                      rules="required|integer|min_value:0"
                    >
                      <b-form-input
                        v-model.number="incentive.update_posting_max"
                        number
                        placeholder="0"
                      />
                      <small class="text-danger d-block mt-[2px]">{{ errors[0] }}</small>
                    </validation-provider>
                    <span class="text-[#6A7282] whitespace-nowrap h-[34.55px] flex items-center">post/bulan (max)</span>
                  </div>
                </div>
              </div>
              <div class="mb-[16px]">
                <div class="text-[#0A0A0A] font-medium text-[14px] mb-[12px]">
                  Update Video
                </div>
                <div class="flex items-start gap-x-[20px] gap-y-[12px] flex-wrap w-fit max-w-[460px] md:max-w-none">
                  <div class="flex items-start gap-[12px] basis-[240px] grow">
                    <validation-provider
                      #default="{ errors }"
                      name="per video"
                      rules="required|integer|min_value:0"
                    >
                      <b-form-input
                        v-model.number="incentive.update_video_rate"
                        number
                        placeholder="Masukkan nominal"
                      />
                      <small class="text-danger d-block mt-[2px]">{{ errors[0] }}</small>
                    </validation-provider>
                    <span class="text-[#6A7282] whitespace-nowrap h-[34.55px] flex items-center">per video</span>
                  </div>
                  <div class="flex items-start gap-[12px] basis-[200px] grow">
                    <validation-provider
                      #default="{ errors }"
                      name="video/bulan (max)"
                      rules="required|integer|min_value:0"
                    >
                      <b-form-input
                        v-model.number="incentive.update_video_max"
                        number
                        placeholder="0"
                      />
                      <small class="text-danger d-block mt-[2px]">{{ errors[0] }}</small>
                    </validation-provider>
                    <span class="text-[#6A7282] whitespace-nowrap h-[34.55px] flex items-center">video/bulan (max)</span>
                  </div>
                </div>
              </div>
              <b-form-group>
                <template #label>
                  Update Produk
                </template>
                <validation-provider
                  #default="{ errors }"
                  name="Update Produk"
                  rules="required|integer|min_value:0"
                >
                  <b-form-input
                    v-model.number="incentive.update_product_rate"
                    number
                    placeholder="Masukkan nominal"
                  />
                  <small class="text-danger d-block mt-[2px]">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-form-group>
                <template #label>
                  Bonus Penjualan
                </template>
                <validation-provider
                  #default="{ errors }"
                  name="Bonus Penjualan"
                  rules="required|integer|min_value:0"
                >
                  <div class="flex items-center gap-[12px]">
                    <b-form-input
                      v-model.number="incentive.sales_bonus_percentage"
                      number
                      placeholder="Masukkan nominal"
                    />
                    <span class="sm:whitespace-nowrap text-[14px] text-[#6A7282]">% dari penjualan/bulan</span>
                  </div>
                  <small class="text-danger d-block mt-[2px]">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-form-group>
                <template #label>
                  Invoice
                </template>
                <validation-provider
                  #default="{ errors }"
                  name="Invoice"
                  rules="required|integer|min_value:0"
                >
                  <div class="flex items-center gap-[12px]">
                    <b-form-input
                      v-model.number="incentive.invoice_rate"
                      number
                      placeholder="Masukkan nominal"
                    />
                    <span class="sm:whitespace-nowrap text-[14px] text-[#6A7282]">per invoice</span>
                  </div>
                  <small class="text-danger d-block mt-[2px]">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-form-group>
                <template #label>
                  Broadcast
                </template>
                <validation-provider
                  #default="{ errors }"
                  name="Broadcast"
                  rules="required|integer|min_value:0"
                >
                  <div class="flex items-center gap-[12px]">
                    <b-form-input
                      v-model.number="incentive.broadcast_rate"
                      number
                      placeholder="Masukkan nominal broadcast"
                    />
                    <span class="sm:whitespace-nowrap text-[14px] text-[#6A7282]">per bulan</span>
                  </div>
                  <small class="text-danger d-block mt-[2px]">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-form-group>
                <template #label>
                  Setting Iklan
                </template>
                <validation-provider
                  #default="{ errors }"
                  name="Setting Iklan"
                  rules="required|integer|min_value:0"
                >
                  <div class="flex items-center gap-[12px]">
                    <b-form-input
                      v-model.number="incentive.setting_ads_rate"
                      number
                      placeholder="Masukkan nominal setting iklan"
                    />
                    <span class="sm:whitespace-nowrap text-[14px] text-[#6A7282]">per bulan</span>
                  </div>
                  <small class="text-danger d-block mt-[2px]">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-form-group>
                <template #label>
                  Setting Affiliate
                </template>
                <validation-provider
                  #default="{ errors }"
                  name="Setting Affiliate"
                  rules="required|integer|min_value:0"
                >
                  <b-form-input
                    v-model.number="incentive.setting_affiliate_rate"
                    number
                    placeholder="Masukkan nominal setting affiliate"
                  />
                  <small class="text-danger d-block mt-[2px]">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <div class="mb-[16px]">
                <div class="text-[#0A0A0A] font-medium text-[14px] mb-[12px]">
                  Lembur
                </div>
                <div class="flex items-start gap-[12px] flex-wrap">
                  <validation-provider
                    #default="{ errors }"
                    name="overtime"
                    rules="required|integer|min_value:0"
                    class="basis-[200px] grow"
                  >
                    <b-form-input
                      v-model.number="incentive.overtime_rate"
                      number
                      placeholder="Masukkan nominal lembur"
                    />
                    <small class="text-danger d-block mt-[2px]">{{ errors[0] }}</small>
                  </validation-provider>
                  <validation-provider
                    #default="{ errors }"
                    name="post/bulan (max)"
                    rules="required"
                    class="basis-[120px] grow sm:grow-0"
                  >
                    <v-select
                      v-model="incentive.overtime_type"
                      label="text"
                      :reduce="option => option.value"
                      :options="overtimeTypes"
                      :clearable="false"
                      class="[&_ul]:!min-w-[120px] [&>div]:h-[34.55px] [&_span]:!m-0"
                    />
                    <small class="text-danger d-block mt-[2px]">{{ errors[0] }}</small>
                  </validation-provider>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-end mt-auto pt-[30px] border-t-[1px] border-[#E2E2E2]">
          <b-button
            variant="outline-primary"
            @click="$bvModal.hide('complete-assignment')"
          >
            Kembali
          </b-button>
          <b-button
            variant="primary"
            class="w-[148px] ml-[12px]"
            :disabled="invalid || loadingSubmit"
            @click.prevent="submit()"
          >
            <b-spinner
              v-if="loadingSubmit"
              small
            />
            {{ mode === 'add' ? 'Tambahkan' : 'Ubah Data' }}
          </b-button>
        </div>
      </validation-observer>
    </b-overlay>
  </b-modal>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { komtimAxiosIns } from '@/libs/axios'
import { alertError, alertSuccess } from '@toast'
import vSelect from 'vue-select'
import { DEFAULT_INCENTIVE } from './config'

export default {
  components: {
    ValidationObserver,
    ValidationProvider,
    vSelect,
  },
  props: {
    talentAssignments: {
      type: Object,
      default: null,
    },
    mode: {
      type: String,
      default: 'add',
    },
    talentExist: {
      type: Array,
      default: () => [],
    },
    deviceExist: {
      type: Array,
      default: () => [],
    },
    idSelected: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      loading: false,
      loadingSubmit: false,
      alertError,
      alertSuccess,

      listTalent: [],
      listPartner: [],
      listLeader: [],
      listDevice: [],
      listOffice: [],
      listSkills: [],

      talent: null,
      partner: null,
      leader: null,
      device: null,
      role: null,
      office: null,
      isNewPartner: false,

      roleFreelance: ['Live Streamer', 'Advertiser'],

      incentive: { ...DEFAULT_INCENTIVE },
      overtimeTypes: [
        { text: 'per jam', value: 'hourly' },
        { text: 'per hari', value: 'daily' },
      ],
    }
  },
  computed: {
    roleId() {
      return this.role ? this.listSkills.find(s => s.name === this.role).id : ''
    },
  },
  mounted() {
    if (this.mode === 'add') this.getListSkills()
  },
  methods: {
    resetAssignment() {
      this.talent = null
      this.partner = null
      this.leader = null
      this.device = null
      this.role = null
      this.office = null
      this.isNewPartner = false
      this.incentive = { ...DEFAULT_INCENTIVE }

      this.listTalent = []
      this.listPartner = []
      this.listLeader = []
      this.listDevice = []
      this.listOffice = []

      this.$bvModal.hide('complete-assignment')
    },
    async submit() {
      if (this.loadingSubmit) return
      this.loadingSubmit = true
      try {
        const dataForEdit = {
          device_id: this.device && this.device.id ? this.device.id : this.talentAssignments.device_id,
          office_id: this.office && this.office.id ? this.office.id : this.talentAssignments.office_id,
          staff_id: this.leader && this.leader.id ? this.leader.id : this.talentAssignments.staff_id,
          incentive: this.role !== 'Admin Marketplace' ? null : this.incentive,
        }
        if (this.mode === 'edit') {
          const url = `v1/partner_assignments/talent/${this.idSelected}/update`
          await komtimAxiosIns.put(url, dataForEdit)
          const text = 'Berhasil menambahkan data'
          this.alertSuccess(text)
          this.resetAssignment()
          this.$emit('updateTalent')
          return
        }
        const data = {
          ...dataForEdit,
          working_space_id: this.office.id,
          talent_id: this.talent.id,
          talent_name: this.talent.full_name,
          partner_id: this.partner.id,
          partner_name: this.partner.name,
          device_name: this.device.device_name,
          staff_name: this.leader.name,
          working_space_name: this.office.working_space_name,
          is_new_partner: this.isNewPartner,
        }
        this.$emit('updateTalent', data)
        this.resetAssignment()
      } catch (error) {
        this.alertError(error)
      } finally {
        this.loadingSubmit = false
      }
    },
    async getListTalent(keyword) {
      this.offset = 0
      const params = `offset=0&limit=20&status=${this.roleFreelance.includes(this.role) ? 'selected,hired,non job,multiple' : 'selected,hired,non job'}&keyword=${keyword}&skill=${this.roleId || ''}`
      const url = `v1/talents?${params}`
      await komtimAxiosIns
        .get(url)
        .then(res => {
          const { data } = res.data
          const filtered = (data || []).filter(el => !this.talentExist.includes(el.id))
          this.listTalent = filtered.map(e => ({ ...e, label: `${e.id} - ${e.full_name}` }))
        })
        .catch(err => {
          this.alertError(err)
          this.loading = false
        })
    },
    searchTalent: _.debounce((search, it) => {
      it.getListTalent(search)
    }, 500),
    onSearchTalent(search) {
      this.searchTalent(search, this)
    },
    async getListPartner(keyword) {
      this.offset = 0
      const params = `offset=0&limit=20&status=registered,active,pause,off&keyword=${keyword}`
      const url = `v1/partners?${params}`
      await komtimAxiosIns
        .get(url)
        .then(res => {
          const { data } = res.data
          this.listPartner = data.map(e => ({ ...e, label: `${e.no_partner} - ${e.name}` }))
        })
        .catch(err => {
          this.alertError(err)
          this.loading = false
        })
    },
    searchPartner: _.debounce((search, it) => {
      it.getListPartner(search)
    }, 500),
    onSearchPartner(search) {
      this.searchPartner(search, this)
    },
    async getListLeader(keyword) {
      this.offset = 0
      const params = `offset=0&limit=20&position_name=Team Lead Non Advertiser,Team Lead Advertiser&keyword=${keyword}`
      const url = `v1/staffs?${params}`
      await komtimAxiosIns
        .get(url)
        .then(res => {
          const { data } = res.data
          this.listLeader = data
        })
        .catch(err => {
          this.alertError(err)
          this.loading = false
        })
    },
    searchLeader: _.debounce((search, it) => {
      it.getListLeader(search)
    }, 500),
    onSearchLeader(search) {
      this.searchLeader(search, this)
    },
    async getListOffice() {
      this.loading = true
      this.offset = 0
      const params = 'status=true'
      const url = `v1/working_spaces/resource?${params}`
      await komtimAxiosIns
        .get(url)
        .then(res => {
          this.loading = false
          const { data } = res.data
          this.listOffice = data
        })
        .catch(err => {
          this.loading = false
          this.alertError(err)
        })
    },
    async getListDevice() {
      this.loading = true
      this.offset = 0
      const params = `offset=0&limit=20&holder_name=IT Support&partner_id=${this.mode === 'add' ? this.partner.no_partner : this.talentAssignments.no_partner}`
      const url = `v1/devices?${params}`
      await komtimAxiosIns
        .get(url)
        .then(res => {
          this.loading = false
          const { data } = res.data
          this.listDevice = (data || []).filter(el => !this.deviceExist.includes(el.id))
        })
        .catch(err => {
          this.loading = false
          this.alertError(err)
        })
    },
    handleInput(val) {
      if (this.mode === 'edit') return
      this.device = null
      if (val) {
        this.getListDevice()
      }
    },
    async getListSkills() {
      this.loading = true
      this.offset = 0
      const params = `active=${true}&type=2`
      const url = `v1/skills/resource?${params}`

      await komtimAxiosIns
        .get(url)
        .then(res => {
          this.loading = false
          const { data } = res.data
          this.listSkills = data
        })
        .catch(err => {
          this.alertError(err)
          this.loading = false
        })
    },
    loadData() {
      this.role = this.talentAssignments.skill_name
      this.talent = this.talentAssignments.talent_name
      this.partner = this.talentAssignments.partner_name
      this.leader = this.talentAssignments.staff_name
      this.device = this.talentAssignments.device
      this.office = this.talentAssignments.office_name
      this.isNewPartner = this.talentAssignments.is_new_partner
      if (this.talentAssignments.incentive) {
        this.incentive = this.talentAssignments.incentive
      }
    },
    handleModalShown() {
      this.getListOffice()
      if (this.mode === 'edit') {
        this.getListDevice()
        this.loadData()
      }
    },
  },
}
</script>
